import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../components/Flex";
import useDisclosure from "../../../../../../../../../../hooks/use-disclosure";
import { StyleAddButton } from "../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import { AddIcdCodes, renderSelectedIcdCodes } from "./Add-ICD-Codes";

interface IcdCodesFieldProps {
  formik: FormikProps<any>;
  label?: string;
  height?: string;
}

/**
 * Renders the "Add ICD Codes" button, the picker drawer, and the selected
 * codes list. Designed to sit side-by-side with `CptCodesField` inside a
 * row-direction flex container.
 *
 * Values live on `formik.values.assessmentCodes`.
 */
const IcdCodesField = ({
  formik,
  label = "Add ICD Codes",
  height = "20vh",
}: IcdCodesFieldProps) => {
  const icdDisclosure = useDisclosure();

  return (
    <Flex flexDirection="column" gap={1} flex={1} minWidth={0}>
      <StyleAddButton
        w="120px"
        onClick={() => icdDisclosure.open()}
        label={label}
      />
      <AddIcdCodes formik={formik} disclosureHost={icdDisclosure} />
      {!!formik.values?.assessmentCodes?.length && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          {renderSelectedIcdCodes(
            formik.values?.assessmentCodes ?? [],
            (code: any) => {
              formik.setFieldValue("assessmentCodes", [
                ...(formik.values?.assessmentCodes ?? []).filter(
                  (it: any) => it.value !== code.value
                ),
              ]);
            },
            height
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default IcdCodesField;
